export default "__VITE_ASSET__DulzB1Yl__"